import { API_MEDIA_UPLOADS, MediaUpload } from './models';
import { apiStatic, getRandomString } from 'AurionCR/components';
import { sanitizeFileName } from '../../components/helpers.ts';

export * from './models';

export interface ValueHtmlContentUploader {
  name: string;
  value: string;
}

class Service {
  async uploadHtml(data: ValueHtmlContentUploader) {
    const { name, value } = data;
    const fileName = sanitizeFileName(
      [getRandomString(20), name].filter(Boolean).join('__') + '_htmlContent.html',
    );
    const blob = new Blob([value], { type: 'text/html' });
    const file = new File([blob], fileName, { type: 'text/html' });

    const formData = new FormData();
    formData.append('file', file);

    return apiStatic.post<Required<MediaUpload>>(API_MEDIA_UPLOADS.UPLOAD_FILE_TO_CLOUD, formData);
  }

  async remove(data: Pick<Required<MediaUpload>, 'filePath'>) {
    try {
      await apiStatic.put(API_MEDIA_UPLOADS.REMOVE_FILE_FROM_CLOUD, { filePath: data.filePath });
    } catch (e) {
      console.warn('Error to remove file');
    }
  }

  async getHtml(fileName: string) {
    try {
      return await apiStatic.post(
        API_MEDIA_UPLOADS.GET_HTML_FROM_CLOUD,
        { fileName },
        { skipSourceUpdate: true },
      );
    } catch (e) {
      console.warn('Error to get html file');
    }
  }
}

export const ServiceMediaUploads = new Service();
